module.exports = __webpack_public_path__ + "img/boolflix-3.34a6dd9b.png";